import { Pagination as FlowbitePagination } from 'flowbite-react';

export type PaginationProps = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
  className?: string;
  showInfo?: boolean;
  nextLabel?: string;
  previousLabel?: string;
};

export const Pagination = ({
  pageNumber,
  pageSize,
  totalCount,
  onPageChange,
  isLoading = false,
  className = '',
  showInfo = true,
  nextLabel = 'Вперёд',
  previousLabel = 'Назад',
}: PaginationProps) => {
  const totalPages = Math.ceil(totalCount / pageSize) || 1;

  if (totalCount <= pageSize) {
    return null;
  }

  const from = (pageNumber - 1) * pageSize + 1;
  const to = Math.min(pageNumber * pageSize, totalCount);

  const handlePageChange = (page: number) => {
    if (!isLoading) onPageChange(page);
  };

  return (
    <div
      className={`flex items-center justify-between border-t border-gray-200 pt-4 ${className}`}
    >
      {showInfo && (
        <div className="text-sm text-gray-500">
          Показано {from}–{to} из {totalCount}
        </div>
      )}
      <FlowbitePagination
        currentPage={pageNumber}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        showIcons
        layout="pagination"
        className={isLoading ? 'pointer-events-none opacity-50' : ''}
      />
    </div>
  );
};
